import React, { useEffect, useState } from 'react';
import StreamingService from '~/api-services/StreamingService';
import { StrategyEvent } from '~/api-services/StreamingService/types';
import { linkTo } from '~/navigation';
import { isDesktop } from '~/constants/scale';
import ConfirmationMessage from '../ConfirmationMessage';

/**
 * Listens for `strategyEvent` messages pushed over the socketserverv4 connection
 * (AI strategy builder progress/result for the logged-in account) and shows them
 * using the standard ConfirmationMessage popup, the same UI used for order events.
 * Tapping the popup opens the strategy (mobile/native layout only — the desktop
 * layout's AI Strategy pane is driven by its own header-tab state, not deep links).
 *
 * Mounted app-wide while logged in. socketserverv4 auto-joins the account's
 * strategies room from the session, so no subscribe/join call is needed here.
 */
const StrategyMessagePopup = () => {
    const [visible, setVisible] = useState(false);
    const [text, setText] = useState('');
    const [strategyId, setStrategyId] = useState<string | null>(null);

    useEffect(() => {
        const cb = (e: StrategyEvent) => {
            if (e.type === 'message') {
                setText(e.text);
                setStrategyId(e.id ?? null);
                setVisible(true);
            }
        };
        StreamingService.subscribeStrategyEvent(cb);
        return () => {
            StreamingService.unsubscribeStrategyEvent(cb);
        };
    }, []);

    const openStrategy = strategyId && !isDesktop() ? () => linkTo(`/aiStrategy/${strategyId}`) : undefined;

    return (
        <ConfirmationMessage
            visible={visible}
            text={text}
            setVisible={setVisible}
            error={false}
            onPress={openStrategy}
        />
    );
};

export default StrategyMessagePopup;
